/**
 * Enrollment Service
 */

import api from '../lib/api';

export const enrollmentService = {
  async getAll(params = {}) {
    const response = await api.get('/enrollments', { params });
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/enrollments/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/enrollments', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`/enrollments/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/enrollments/${id}`);
    return response.data;
  }
};
